export const unsanitize = (str: string) => {
  const ta = document.createElement('textarea')
  ta.innerHTML = str
  return ta.value
}
